namespace GeniuzPOS.Inventory {
    export class IcStockCountTranColumns {
        static columnsKey = 'Inventory.IcStockCountTran';
    }
}
